import Analytics from "@sentrei/common/models/Analytics";

// eslint-disable-next-line import/prefer-default-export
export const analyticsStats: Analytics.Stats = {
  profiles: null,
  notifications: null,
  rooms: null,
  spaces: null,
  users: null,
  usernames: null,
};
